export const randomNumber = (min, max) => {
  const updatedMin = Math.ceil(min)
  const updatedMax = Math.floor(max)
  return Math.floor(Math.random() * (updatedMax - updatedMin + 1)) + updatedMin
}
